<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="phone">
        <el-input v-model="queryParams.phone" placeholder="手机号"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="nickname">
        <el-input v-model="queryParams.nickname" placeholder="昵称"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="openId" >
        <el-input v-model="queryParams.openId" placeholder="OpenID"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 内容部分 -->
    <el-table :data="tableData" border @sort-change="tableSortChange">
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="phone" label="手机号" align="center" width="120px"></el-table-column>
      <el-table-column prop="nickname" label="昵称" align="center"></el-table-column>
      <el-table-column prop="openid" label="OpenID" align="center" min-width="80" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="wxUserId" label="微信用户ID" align="center" min-width="100" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="totalIntegral" label="总积分" align="center" min-width="100px" sortable="custom"></el-table-column>
      <el-table-column prop="cardIntegral" label="卡积分" align="center" min-width="100px" sortable="custom"></el-table-column>
      <el-table-column prop="userIntegral" label="账户积分" align="center" min-width="100px" sortable="custom"></el-table-column>
      <el-table-column prop="cardNumber" label="卡数量" align="center" min-width="100px" sortable="custom"></el-table-column>
      <el-table-column prop="amount" label="余额" align="center" min-width="80px" sortable="custom"></el-table-column>
      <el-table-column prop="monthSale" label="充值金额" align="center" min-width="100px" sortable="custom"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" min-width="160" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="操作" width="150" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-view" @click="editRow(scope.row.userId)" v-hasPermi="['user:wxBind:detail']">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
  </div>
</template>
<script>
import { userWxMpList } from "@/api/api.js"; //用户列表获取初始化数据
export default {
  name: "userBindList",
  data() {
    return{
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      an:false,
      sortOrder:"",
      sortName:"",
      operator:[
        { label: "2",value: '充电桩', },
        { label: "4",value: '售货机', },
        { label: "3",value: '执法仪', },
        { label: "1",value: '监控', },
        { label: "5",value: '门禁', },
        { label: "6",value: '其他', },
      ],
    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams,
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      userWxMpList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 排序
    tableSortChange(val){
      this.sortOrder = val.order === "descending" ? "desc" : "asc";
      if(val.prop == "userIntegral"){
        this.sortName = "user_integral"
      }else if(val.prop == "cardNumber"){
        this.sortName = "card_number"
      }else if(val.prop == "amount"){
        this.sortName = "amount"
      }else if(val.prop == "monthSale"){
        this.sortName = "month_sale"
      }else if(val.prop == "totalIntegral"){
        this.sortName = "total_integral"
      }else if(val.prop == "cardIntegral"){
        this.sortName = "card_integral"
      }
      this.initData();
    },
    // 搜索
    search() {
      this.page = 1,
          this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.search();
    },
    // 跳转详情
    editRow(userId) {
      this.$router.push('/userCenter/wxMpUserInfo/'+userId );
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData();
    },

  },
  created() {
    this.initData();
  },
  mounted() {

  },

};
</script>

<style scoped lang="less">
</style>


